// The internal team, used wherever the dashboard needs to know "who is acting":
// the top-bar current-user selector and Google Watchdog's "Who are you?" prompt.
// Attribution only (e.g. who created a video-editing project) — never an
// authorization signal.
// 'Agent' is the agent hub's browser (its runs act on the dashboard too; Kevin, 2026-10-22).
export const TEAM = ['Aaron', 'Camden', 'Colby', 'Inno', 'Kevin', 'Marsha', 'Serene', 'Agent'];
